import { render, staticRenderFns } from "./workspace-question-set-detail.vue?vue&type=template&id=2e826eca&scoped=true&"
import script from "./workspace-question-set-detail.vue?vue&type=script&lang=js&"
export * from "./workspace-question-set-detail.vue?vue&type=script&lang=js&"
import style0 from "./workspace-question-set-detail.vue?vue&type=style&index=0&id=2e826eca&lang=scss&scoped=true&"
import style1 from "./workspace-question-set-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e826eca",
  null
  
)

export default component.exports